import LayoutBasic from "@/views/layouts/LayoutBasic";
import InvoicesNew from "@/views/admin/invoices/new";
import InvoiceTransits from "@/views/admin/invoices/InvoiceTransits";
import InvoicesList from "@/views/admin/invoices/list";
import InvoiceIncome from "@/views/admin/invoices/income";
import InvoiceShift from "@/views/admin/invoices/shift";
import InvoicesEdit from "@/views/admin/invoices/edit";
import CostPrice from "@/views/admin/invoices/costPrice";
import Suppliers from "@/views/admin/invoices/Suppliers";
import Orders from "@/views/admin/invoices/Orders";
import ManageOrders from "@/views/admin/invoices/ManageOrders.vue";
import SuppliersCountries from "@/views/admin/invoices/Countries.vue";

const routes = {
  path: '/invoices',
  component: LayoutBasic, // Change the desired Layout here
  meta: {requiresAuth: true},
  children: [
    {
      path: 'new',
      name: 'InvoicesNew',
      component: InvoicesNew
    },
    {
      path: 'transits',
      name: 'InvoiceTransits',
      component: InvoiceTransits
    },
    {
      path: 'list/:type?',
      name: 'InvoicesList',
      component: InvoicesList
    },
    {
      path: 'create/income',
      name: 'InvoiceIncome',
      component: InvoiceIncome
    },
    {
      path: 'create/shift',
      name: 'InvoiceShift',
      component: InvoiceShift
    },
    {
      path: 'edit/:id',
      name: 'InvoicesEdit',
      component: InvoicesEdit
    },
    {
      path: 'costprice',
      name: 'CostPrice',
      component: CostPrice
    },
    {
      path: 'suppliers',
      name: 'Suppliers',
      component: Suppliers
    },
    {
      path: 'countries',
      name: 'SuppliersCountries',
      component: SuppliersCountries
    },
    {
      path: 'orders',
      name: 'SupplyOrders',
      component: Orders
    },
    {
      path: 'manage/orders',
      name: 'ManageInvoicesToOrders',
      component: ManageOrders
    },
  ]
}

export default routes
